import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchPagination } from '@uncinc/react-searchkit';

import { Icon } from '@uncinc/uncinc-react-kitchen-sink';

export interface SearchAllContentPaginationProps {
  disableScrollTo?: boolean;
  className?: string;
}

const SearchAllContentPagination: React.FC<SearchAllContentPaginationProps> = (props) => {
  const { className, disableScrollTo = false } = props;

  const { t } = useTranslation('translation', { keyPrefix: 'searchkit.pagination' });

  const classNames = c('SearchAllContent__Pagination', className);

  return (
    <div className={classNames}>
      <SearchPagination
        disableScrollTo={disableScrollTo}
        // @ts-expect-error - prop is not typed in RKS.
        pageRangeDisplayedPerViewPort={{
          xs: 1,
          sm: 3,
          md: 3,
          lg: 5,
          xl: 5,
        }}
        previousLabel={(
          <>
            <Icon name="arrow_back" flair="filled" />
            <span>{t('prev_label')}</span>
          </>
        )}
        nextLabel={(
          <>
            <span>{t('next_label')}</span>
            <Icon name="arrow_forward" flair="filled" />
          </>
        )}
      />
    </div>
  );
};

export default SearchAllContentPagination;
